module.exports = __webpack_public_path__ + "static/media/pking.c29bb895.png";